// `pdfjs-dist` 3.x ships modern class-field/private-method syntax. We patch the
// package's `main` field to point at `legacy/build/pdf.js` (the broader-compat
// build, required for CRA 4 / webpack 4) — see patches/pdfjs-dist+3.11.174.patch.
// This means importing from "pdfjs-dist" resolves to the legacy build for both
// our code and react-pdf-viewer's internal imports.
// CRA's `babel-preset-react-app` still needs a class-field-aware preset-env to
// transpile that build; see the `overrides` block in package.json.
import { GlobalWorkerOptions } from 'pdfjs-dist';

// Worker URL must stay in lockstep with the installed pdfjs-dist version
// in package.json. A mismatch between API and worker silently produces
// black/blank pages and intermittent render failures.
export const PDFJS_WORKER_URL =
    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

GlobalWorkerOptions.workerSrc = PDFJS_WORKER_URL;
